import useAuth from "hooks/UseAuth";
import { useState } from "react";

import {
  Docs, DocsProgress, ICircularCheck, IFeatherSend, IHourGlass
} from "./_documentsPainel";


interface IDocumentsPainelProps {
  onClick: () => void;
}

export const DocumentsPainel = ({ onClick }: IDocumentsPainelProps) => {
  const { user } = useAuth()

  const [documentStatus] = useState<number>(user?.documents_status || 0);

  if([1,2].includes(documentStatus)) {
    return (
      <DocsProgress
        status={documentStatus}
      >
        <h1 className="docs__title">
          Envio de documentação
        </h1>

        <h2 className="docs__feedback">
          Status da documentação
          {' '}
          -
          {' '}
          {documentStatus === 1
            ? 'Pendente'
            : 'Concluído'
          }
        </h2>

        <div className="docs__status-container">
          <span className="docs__status-step">
            <IFeatherSend />
          </span>
          <span className="docs__status-step">
            <IHourGlass />
          </span>
          <span className="docs__status-step">
            <ICircularCheck />
          </span>
        </div>
      </DocsProgress>
    );
  }

  return (
    <Docs>
      <span className="docs__title">
        Envio de documentação
      </span>

      <span className="docs__feedback">
        Status da documentação
        {' '}
        -
        {' '}
        {documentStatus === 0
          ? 'Pendente'
          : 'Reprovado'
        }
      </span>

      {documentStatus === 3 && (
        <span className="docs__feedback">
          Envie novamente
        </span>
      )}

      <button
        type="button"
        className="docs__documentation-button"
        onClick={onClick}
      >
        Enviar Documentação
      </button>
    </Docs>
  );
};
